import React from "react";
import clsx from "clsx";
import IconCrossSmall from "@assets/icon_cross_small.svg";
import { IconButton } from "@components";
import styles from "./CloseButton.module.scss";
export function CloseButton({ className, onRequestClose }) {
    return (React.createElement(IconButton, { type: "button", color: "secondary", icon: React.createElement(IconCrossSmall, null), className: clsx(styles.closeButton, className), onClick: () => onRequestClose() }));
}
